export default "__VITE_ASSET__3fa0396d__"